export const userKeys = {
  all: ["users"] as const,
  lists: () => [...userKeys.all, "list"] as const,
  list: (params?: Record<string, unknown>) =>
    [...userKeys.lists(), params] as const,
  details: () => [...userKeys.all, "detail"] as const,
  detail: (id: string) => [...userKeys.details(), id] as const,
  rolesForSelect: () => [...userKeys.all, "roles-for-select"] as const,
  // Auth / profile
  profile: ["auth-profile"] as const,
};
